module.exports = __webpack_public_path__ + "resources/images/efteling-b96754f2c04838c51741d9a971f1600a-cache.jpeg";